export function convertOTimeToLocation(utcTimeStr) {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Use today's date
    const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    // Combine date with time and specify UTC
    const utcFullString = `${today} ${utcTimeStr} UTC`;

    const utcDate = new Date(utcFullString);

    if (isNaN(utcDate.getTime())) {
        console.warn("Invalid time input:", utcTimeStr);
        return utcTimeStr;
    }

    // Convert to local time and format as hh:mm AM/PM
    const options = {
        timeZone,
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    };

    return new Intl.DateTimeFormat("en-US", options).format(utcDate);
}

export const formatTime = (t) => {
  const totalSecs = Math.ceil(Number(t) || 0);
  const minutes = Math.floor(totalSecs / 60);
  const seconds = (totalSecs % 60).toString().padStart(2, "0");
  return `${minutes}:${seconds}`;
};

export const formatToReadableDate = (isoString) => {
  const date = new Date(isoString);

  const day = new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
  }).format(date);

  const weekday = new Intl.DateTimeFormat("en-US", {
    weekday: "short",
  }).format(date);

  const year = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
  }).format(date);

  return `${day} ${weekday}, ${year}`;
};